<script>
    import {locals} from "../../../ts/stores.js";
</script>

<style>
    footer {
        padding: 8px;
        text-align: center;
    }
</style>

<footer>{$locals.app.name} v{$locals.app.version} - all rights reserved.</footer>
